import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var TrophySVG = function TrophySVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M27.54,24.12A9.48,9.48,0,0,0,28,21.367v-9.1A2.269,2.269,0,0,0,25.731,10H12.12a2.269,2.269,0,0,0-2.268,2.269v9.074a9.593,9.593,0,0,0,.465,2.779l1.2,2.775c1.5,2.709,3.851,5.071,6.309,5.643h2.21c2.46-.572,4.81-2.938,6.312-5.644Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M25.253,14.826,23.4,14.482l-.9-1.763c-.211-.415-.558-.415-.77,0l-.9,1.763-1.852.344c-.461.085-.578.436-.262.779l1.32,1.432-.265,1.987c-.062.461.229.665.646.454l1.7-.863,1.7.863c.417.211.708.007.647-.454L24.2,17.037l1.319-1.432C25.832,15.262,25.714,14.911,25.253,14.826Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M30.416,24.423c11.2-2.713,9.5-14.109,9.482-14.226a1.286,1.286,0,0,0-1.27-1.082H32.3V7.828a2.574,2.574,0,0,0-2.574-2.574H14.279a2.574,2.574,0,0,0-2.574,2.574V9.115H5.372A1.286,1.286,0,0,0,4.1,10.2c-.019.117-1.715,11.516,9.486,14.227,1.705,3.074,4.369,5.754,7.159,6.4a1.122,1.122,0,0,0-.034.165v6.434H14.279a1.287,1.287,0,1,0,0,2.574H29.721a1.287,1.287,0,0,0,0-2.574H23.287V30.992a1.122,1.122,0,0,0-.034-.165C26.045,30.178,28.711,27.494,30.416,24.423Zm7.029-12.734c.068,2.242-.407,7.321-5.672,9.585a10.777,10.777,0,0,0,.522-3.123V11.689Zm-30.89,0h5.15v6.434a10.851,10.851,0,0,0,.528,3.153C6.961,19.013,6.486,13.929,6.555,11.689ZM22,28.418c-2.979,0-7.721-5.621-7.721-10.295V7.828H29.721V18.151C29.721,22.812,24.979,28.418,22,28.418Z"
  }));
};
TrophySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
TrophySVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Trophy")
};
export default withDetailedIcon(TrophySVG);